import { Store } from 'rxjs-observable-store';
import { SearchTerm } from './models/search_term';
import * as i0 from "@angular/core";
export class SearchTermService extends Store {
    constructor() {
        super(new SearchTerm());
    }
}
SearchTermService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SearchTermService_Factory() { return new SearchTermService(); }, token: SearchTermService, providedIn: "root" });
